import {
  getRationPercentValue,
  getPercentageValue,
  arrayToSimpleObj,
} from '@op/utils';

function calculateValue({
  oldValueMap,
  newValueMap,
  key,
  oldTotalMap,
  newTotalMap,
}: {
  oldValueMap: { [key: string]: number };
  newValueMap: { [key: string]: number };
  key: string;
  oldTotalMap: { [key: string]: number };
  newTotalMap: { [key: string]: number };
}) {
  const oldValue = oldValueMap?.[key] || 0;
  const newValue = newValueMap[key] || 0;

  // 环比
  const qoq = getRationPercentValue(newValue, oldValue);
  const oldKey = `${key}_old`;
  const qoqKey = `${key}_qoq`;
  const result = {
    [oldKey]: oldValue,
    [qoqKey]: qoq,
    [key]: newValue,
  };

  const oldTotal = oldTotalMap[key];
  const newTotal = newTotalMap[key];

  // 新声量占比
  const ratio = getPercentageValue(newValue, newTotal, 6);
  // 老声量占比
  const oldRatio = getPercentageValue(oldValue, oldTotal, 6);
  // 声量占比环比
  const ratioQoq = getRationPercentValue(ratio, oldRatio);

  return {
    ...result,
    [`${key}_ratio`]: ratio,
    [`${key}_ratio_old`]: oldRatio,
    [`${key}_ratio_qoq`]: ratioQoq,
  };
}

function calculateTableData({
  metrics,
  oldMetrics,
  totalMap,
  oldTotalMap,
}: {
  metrics: { [key: string]: number };
  oldMetrics: { [key: string]: number };
  totalMap: { [key: string]: number };
  oldTotalMap: { [key: string]: number };
}) {
  return Object.keys(metrics || {}).reduce((pre: any, key: string) => {
    const data = calculateValue({
      oldValueMap: oldMetrics,
      newValueMap: metrics,
      key,
      newTotalMap: totalMap,
      oldTotalMap,
    });
    return { ...pre, ...data };
  }, {});
}

export function dealwithNIKKEList(data: any, filter: any) {
  const {
    old_start_date,
    old_end_date,
    new_start_date,
    new_end_date,
    list,
    old_list,
    old_total_metrics,
    total,
    total_metrics,
  } = data;

  const oldListMap = arrayToSimpleObj(old_list, 'metrics', 'topic');

  // 转化为占总量的百分比
  const totalMentions: { [key: string]: number } = {
    ...total_metrics,
    engagement: total_metrics.views,
    negative_mentions: total_metrics.mentions,
    positive_mentions: total_metrics.mentions,
  };
  const oldTotalMentions: { [key: string]: number } = {
    ...old_total_metrics,
    engagement: old_total_metrics.views,
    negative_mentions: old_total_metrics.mentions,
    positive_mentions: old_total_metrics.mentions,
  };
  const result = (list || []).map(({ topic, child_topics, metrics }: any) => {
    // 计算环比
    const oldMetrics = oldListMap[topic];
    const values = calculateTableData({
      metrics,
      oldMetrics,
      totalMap: totalMentions,
      oldTotalMap: oldTotalMentions,
    });

    return {
      topic,
      child_topics,
      newTimes: [new_start_date, new_end_date],
      oldTimes: [old_start_date, old_end_date],
      ...values,
    };
  });

  return {
    tableData: result,
    total: total || 0,
  };
}
